import React from 'react';
import PropTypes, { InferProps } from 'prop-types';
import { Link } from 'react-router-dom';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Table from '@mui/material/Table';
import { SxStyle } from '../../../types';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import Typography from '@mui/material/Typography';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { useCollection, useDocumentData } from 'react-firebase-hooks/firestore';
import firebaseApp from '../../../firebase-app';
import ExternalIpList from './network-configurator-components/external-ip-list';
import { useStringsContext } from '../../../contexts/strings';
import Loading from '../../loading';
import { collection, doc, updateDoc } from 'firebase/firestore';
import { ExternalIp } from './types';

const styles: SxStyle = {
  loadingContainer: {
    overflow: 'auto',
    minHeight: '70vh',
    maxHeight: '70vh',
  },
  progress: {
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  root: {
    minWidth: 275,
  },
  header: {
    paddingLeft: '5px',
    width: '100%',
  },
};

ConfigRow.propTypes = {
  row: PropTypes.any,
};

function ConfigRow({ row }: InferProps<typeof ConfigRow.propTypes>) {
  const { strings } = useStringsContext();

  return (
    <>
      <TableRow sx={styles.root}>
        <TableCell>{row.key}</TableCell>
        <TableCell>{row?.arena}</TableCell>
        <TableCell>{row?.ipRange}</TableCell>
        <TableCell>
          <Stack spacing={2} direction={'row'} justifyContent={'flex-end'}>
            <Button
              variant="contained"
              component={Link}
              to={'/wifi/networkconfigurator/' + row?.key}
              color="primary"
            >
              {strings.wifi.editNetworkConfig}
            </Button>
            <Button
              variant="contained"
              component={Link}
              to={'/wifi/arenaconfigurator/' + row?.key}
              color="primary"
            >
              {strings.wifi.editArenaConfig}
            </Button>
          </Stack>
        </TableCell>
      </TableRow>
    </>
  );
}

function NetworkOverview() {
  const { strings } = useStringsContext();
  const [ipRangesRawSe, loadingSe] = useCollection(
    collection(firebaseApp.db, '/wifi/sv/ip-ranges')
  );

  const [ipRangesRawNo, loadingNo] = useCollection(
    collection(firebaseApp.db, '/wifi/no/ip-ranges')
  );

  const [externalIpList, loading2] = useDocumentData(doc(firebaseApp.db, '/wifi/wan'));

  if (!loadingSe && !loading2 && externalIpList !== undefined && !loadingNo) {
    const ipRangeConfigsSe =
      ipRangesRawSe?.docs.map((doc: any) => {
        const data = doc.data();
        return { ...data, key: doc?.id };
      }) || [];

    const ipRangeConfigsNo =
      ipRangesRawNo?.docs.map((doc: any) => {
        const data = doc.data();
        return { ...data, key: doc?.id };
      }) || [];

    const iprangeConfigs = ipRangeConfigsSe.concat(ipRangeConfigsNo);

    const submitNewExternalIpList = async (list: ExternalIp[]) => {
      const docRef = doc(firebaseApp.db, '/wifi/wan');
      await updateDoc(docRef, {
        ipRanges: list,
      });
    };

    return (
      <Stack spacing={2}>
        <Typography sx={styles.header}>{strings.wifi.arenaConfig}</Typography>
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>{strings.wifi.headerKey}</TableCell>
                <TableCell>{strings.wifi.headerArena}</TableCell>
                <TableCell>{strings.wifi.headerRanges}</TableCell>
                <TableCell />
              </TableRow>
            </TableHead>
            <TableBody>
              {iprangeConfigs.map((row: any) => (
                <ConfigRow key={row.key} row={row} />
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <Typography sx={styles.header}>{strings.wifi.externalIpConfig}</Typography>
        <Paper sx={styles.root}>
          <ExternalIpList
            externalIpList={externalIpList?.ipRanges}
            submitNewExternalIpList={submitNewExternalIpList}
          />
        </Paper>
      </Stack>
    );
  } else {
    return <Loading />;
  }
}

export default NetworkOverview;
